<template>
  <div class="px- py-3 flex flex-col xl:flex-row justify-between xl:space-x-4 space-y-4 md:space-y-0">
    <div class="max-w-6xl flex-shrink-0 w-full xl:w-4/5 mb-4">
      <div class='flex flex-col-reverse md:flex-row justify-between items-end px-2 md:px-0'>
        <div class="w-full md:w-128">
          <p class="text-3xl font-light">Class Configs</p>
          <multiselect v-model="selectedConfig" @input="newConfigChosen" :options="adminData.class_configurations" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Select a Class Config" label="name" :preselect-first="false" :custom-label="(option) => {return option.identifier}" :hideSelected="false">
          </multiselect>
        </div>
        <div class="">
          <div class="mb-1 relative flex items-center" v-if="isSuperUser">
            <div class="flex h-5 items-center">
              <input v-model="useOldConfig" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
            </div>
            <div class="ml-1 text-sm">
              <div class="flex items-center space-x-1">
                <label for="comments" class="font-medium text-gray-700">Use Old Config</label>
              </div>
            </div>
          </div>
          <button class="btn btn-blue" @click="newClassConfig">New Config</button>
          <!--<button class="btn btn-green" @click="openModalClicked('eventShowType', {})">New Class List</button>-->
        </div>
      </div>
      <hr class="my-4">
      <div v-if="selectedConfig" class="rounded-t">
        <div class="flex flex-col sm:flex-row items-end justify-between py-2.5 px-4 bg-gray-200 rounded-t">
          <div class="w-full md:w-2/3">
            <label class="form-label">Internal Class List ID</label>
            <input class="new-form-input mt-1 w-72" v-model="selectedConfig.identifier" for="label/name" placeholder="Class List Label">
          </div>
          <div class="flex items-center mt-2 sm:mt-0 space-x-2">
            <button class="btn-sm btn-green" @click="saveClassConfig">Save Config</button>
            <button class="btn-sm btn-red-outline" @click="deleteClassConfig">Delete</button>
          </div>
        </div>
        <div class="pt-3">
          <DivisionConfig v-if="selectedConfig && isSuperUser && useOldConfig" :config="selectedConfig.config" :level="0" @templateSet="setTemplate" :class_configuration_id="selectedConfig.class_configuration_id"/>
          <SimpleClassListConfig v-else-if="selectedConfig && isSupportUser" :selectedTemplate="selectedConfig" :breeds="speciesData.breeds" :baseConfig="selectedConfig.config"/>
        </div>
      </div>
    </div>
    <preview-class-list class="" v-if="selectedConfig" :config="selectedConfig.config"/>
  </div>
</template>

<script>
import Vue from 'vue'
import DivisionConfig from '@/components/admin/classListConfig/DivisionConfig.vue'
import PreviewClassList from '@/components/admin/classListConfig/PreviewClassList.vue'
import SimpleClassListConfig from '@/components/admin/classListConfig/SimpleClassListConfig.vue'

export default {
  components: {
    DivisionConfig,
    PreviewClassList,
    SimpleClassListConfig
  },
  data () {
    return {
      useOldConfig: false,
      selectedConfig: null,
      generatedList: [],
      creatingNewConfig: false,
      speciesData: {
        breeds: []
      }
    }
  },
  methods: {
    generateClassList () {
      this.axios.post(`${process.env.VUE_APP_ROOT_API}/generateClassList`, {config: this.selectedConfig.config})
        .then(response => {
          this.generatedList = response.data.data
        })
    },
    setTemplate (template) {
      this.selectedConfig.config = template
    },
    saveClassConfig () {
      this.selectedConfig.event_id = this.adminData.event.event_id
      this.$store.state.apiInstance.post(`${process.env.VUE_APP_ROOT_API}/saveClassConfiguration`, {config: this.selectedConfig})
        .then(response => {
          this.selectedConfig.config = response.data.data.config.config
          if (!this.selectedConfig.class_configuration_id) {
            this.selectedConfig.class_configuration_id = response.data.data.config.class_configuration_id
            this.adminData.class_configurations.push(this.selectedConfig)
          }
          this.selectedConfig.class_configuration_id = response.data.data.config.class_configuration_id
          this.notie.alert({
            type: 1,
            text: `Class Config Saved`
          })
        })
    },
    deleteClassConfig () {
      this.$store.state.apiInstance.post(`${process.env.VUE_APP_ROOT_API}/deleteClassConfiguration`, {class_configuration_id: this.selectedConfig.class_configuration_id})
        .then(response => {
          let index = this.adminData.class_configurations.findIndex(c => c.class_configuration_id === this.selectedConfig.class_configuration_id)
          this.adminData.class_configurations.splice(index, 1)
          this.selectedConfig = null
          this.notie.alert({
            type: 2,
            text: `Class Config Deleted`
          })
        })
    },
    newClassConfig () {
      this.creatingNewConfig = true
      this.selectedConfig = {
        config: {
          champion_title: 'Overall',
          division_champion_title: 'Champion',
          classes: [],
          divisions: []
        }
      }
    },
    newConfigChosen () {
      this.creatingNewConfig = false
      /* if (!this.selectedConfig.class_config) {
        this.selectedConfig.class_config = this.selectedConfig.config
      } */
      if (!this.selectedConfig.config.classes) {
        Vue.set(this.selectedConfig.config, 'classes', [])
      }
      if (!this.selectedConfig.config.divisions) {
        Vue.set(this.selectedConfig.config, 'divisions', [])
      } else {
        this.selectedConfig.config.divisions.forEach(d => {
          if (!d.classes) {
            Vue.set(d, 'classes', [])
          }
          if (!d.divisions) {
            Vue.set(d, 'divisions', [])
          }
        })
      }
      this.getSpeciesData()
    },
    getSpeciesData () {
      let est = this.adminData.event.show_types.filter(st => st.class_list_id === this.selectedConfig.class_configuration_id)[0]
      let show = null
      if (est) {
        show = this.adminData.event.shows.filter(s => {
          if (est.show_ids.includes(s.show_id)) {
            return s
          }
        })[0]
      }
      if (show) {
        this.$store.state.apiInstance.get(`/getSpeciesTypeData/${show.species}`)
          .then(response => {
            this.speciesData = response.data.data
            if (!this.speciesData) {
              this.speciesData = {
                breeds: []
              }
            }
          })
      }
    }
  },
  computed: {
    adminData () {
      return this.$store.state.admin.adminData
    },
    event () {
      return this.adminData.event
    },
    currentUser () {
      return this.$store.state.user
    },
    isAssesmentUser () {
      if (this.currentUser.user_id === 'KFtUZcXZ1ITCICo8w0kZdJHB65n1' && this.event.event_id === 'ce97824c-1df8-11ef-8e5d-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === 'PaFB62Hpp4V3BlrUFebP3MRNi0g2' && this.event.event_id === '1d7af7ce-1e10-11ef-b2db-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === 'MhDTB3YTmTgMZB9g2lVoflY1luO2' && this.event.event_id === '636ee696-1e10-11ef-ad80-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === 'gsXtVouX3HUQZM8qvrVTa2efLOK2' && this.event.event_id === 'a3e57334-1e10-11ef-a269-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === '3PyICPP8s3OPx7F7BIvV3kRx1OD3' && this.event.event_id === 'bd174d14-1e10-11ef-bd1d-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === 'ECXhYgYtmnUmN8i19kP5vZp5Ulj2' && this.event.event_id === '6f670c58-e7ba-11ee-b65a-1248ddbb6de9') {
        return true
      } else {
        return false
      }
    },
    isSupportUser () {
      return this.currentUser.role === 'ADMIN' || this.isSuperUser || this.isAssesmentUser
    },
    isSuperUser () {
      return this.currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2' || this.currentUser.user_id === 'yJcDi4z2bffFtKq1jXI3deN8M9r1' || this.currentUser.user_id === '2S1n15f3I0OJjgpLx5pMlHdAfT13'
    }/* ,
    calculatedSpecies () {
      let shows = []
      if (this.selectedConfig) {
        console.log(this.selectedConfig)
        shows = this.adminData.event.show_types.filter(st => st.class_list_id === this.selectedConfig.class_configuration_id)[0]
        // console.log(est)
        // shows = this.adminData.event.shows.filter(s => s.entry_details_id === est)
      }
      return shows
    } */
  }
}
</script>

<style>

</style>
